export default __webpack_public_path__ + "static/media/1.aa3241f6.png";